<template>
    <div class="lgnswitch">
  <select class="selectpicker form-select" name="countries" v-model="$i18n.locale" @change="changeLanguage">
    <option value="en"><span class="emoji">🇺🇸</span> English </option>
    <option value="africa"><span class="emoji">🇿🇦</span> African </option>
    <option value="french"><span class="emoji">🇲🇫</span> French </option>
    <option value="german"><span class="emoji">🇩🇪</span> German </option>
    <option value="italian"><span class="emoji">🇮🇹</span> Italian </option>
    <option value="spanish"><span class="emoji">🇪🇸</span> Spanish </option>
    <option value="thai"><span class="emoji">🇹🇭</span> Thai </option>
</select>

    </div>
</template>

<script>

// import $ from 'jquery';
export default {
    name: "Language",
    data() {
        return {
            checkLang: localStorage.getItem('language'),
            defultLang: 'en',
            options: [
                { value: 'en', name: 'English', image: 'australia.svg' },
                { value: 'africa', name: 'Africa', image: 'india-grid.svg' },
            ]

        }
    },
    computed: {

    },
    mounted() {
        if (localStorage.getItem('language') == null) {
            this.checkLang = this.defultLang
            this.$i18n.locale = this.checkLang
        }
        if (this.checkLang !== this.$i18n.locale) {
            this.$i18n.locale = this.checkLang
        }

    },
    methods: {
        changeLanguage(obj) {
            localStorage.setItem('language', obj.target.value)
            // console.log(obj.target.value)
            this.scrollBehavior()
        },
        scrollBehavior() {
        document.getElementById('app').classList.add("my-bg-class");
        setTimeout(() => {
            document.getElementById('app').scrollIntoView();
            document.getElementById('app').classList.remove("my-bg-class");
        }, 2000);

    }


    }
    
   

}
</script>
<style lang="scss" scoped>
@import "@/assets/sass/config/variables.scss";
@import "@/assets/sass/main.scss";


</style>

